import {
  TableColumn,
  StatusBadge,
  types,
  utils,
  Badge
} from "@vilocnv/allsetra-core";
import { MileageIcon } from "assets/icons";

export const ACCOUNT_KEYS_TABLE_COLUMNS = (
  translator: any,
  data?: types.IKey[]
): TableColumn<types.IKey>[] => [
  {
    name: "№",
    selector: (row: types.IKey) => {
      const index =
        data?.findIndex((item) => item.uniqueId === row.uniqueId) ?? -1;
      return index >= 0 ? index + 1 : "";
    },
    sortable: false,
    width: "60px"
  },
  {
    name: translator("tableHeading.status", {
      ns: "tableHeadingsTranslation"
    }),
    cell: (row: types.IKey) => <StatusBadge isDeactivated={!row?.isActive} />,
    sortable: true,
    sortField: "isActive",
    width: "80px"
  },
  {
    name: translator("tableHeading.label", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: types.IKey) => row.label || "",
    sortable: true,
    sortField: "label"
  },
  {
    name: translator("tableHeading.keyID", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: types.IKey) => row?.keyId || "",
    sortable: true,
    sortField: "keyId"
  },

  {
    name: translator("tableHeading.activationTimeStamp", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: types.IKey) =>
      row.activationDate
        ? utils.formatDate({ date: row?.activationDate })
        : "N/A",
    sortable: true,
    sortField: "activationDate"
  },
  {
    name: translator("tableHeading.deactivationTimeStamp", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: types.IKey) =>
      row.deactivationDate
        ? utils.formatDate({ date: row?.deactivationDate })
        : "N/A",
    sortable: true,
    sortField: "deactivationDate"
  },
  {
    name: translator("tableHeading.privateMileage", {
      ns: "tableHeadingsTranslation"
    }),
    selector: (row: types.IKey & { yearPrivateMileage: any }) =>
      row?.yearPrivateMileage !== undefined &&
      row?.yearPrivateMileage !== null ? (
        <Badge
          colorScheme={"info"}
          icon={<MileageIcon />}
          textVariant={"small"}
        >
          {row?.yearPrivateMileage?.toFixed(1)} km
        </Badge>
      ) : (
        "N/A"
      ),
    sortable: true,
    sortField: "yearPrivateMileage"
  }
];
